import { Component, OnInit, AfterViewInit, ChangeDetectorRef, Output, EventEmitter, OnDestroy } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { MiCuentaResumen, MiCuentaService } from "src/app/services/mi-cuenta.service";
import { LayoutService } from "../../../../_metronic/core";
import { AuthService } from "../../../../modules/auth/_services/auth.service";
import { UserModel } from "../../../../modules/auth/_models/user.model";
import KTLayoutQuickSearch from "../../../../../assets/js/layout/extended/quick-search";
import KTLayoutQuickNotifications from "../../../../../assets/js/layout/extended/quick-notifications";
import KTLayoutQuickActions from "../../../../../assets/js/layout/extended/quick-actions";
import KTLayoutQuickCartPanel from "../../../../../assets/js/layout/extended/quick-cart";
import KTLayoutQuickPanel from "../../../../../assets/js/layout/extended/quick-panel";
import KTLayoutQuickUser from "../../../../../assets/js/layout/extended/quick-user";
import KTLayoutHeaderTopbar from "../../../../../assets/js/layout/base/header-topbar";
import { KTUtil } from "../../../../../assets/js/components/util";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { NotificationService } from "src/app/services/notification.service";
import { MsalUserProfile } from "src/app/shared/models/MsalUserProfile";
import { RegistroAlerta } from "src/app/models/Alertas/RegistroAlerta";
import { faGrinTongueSquint } from "@fortawesome/free-solid-svg-icons";
import { Divisa } from "src/app/models/Divisa";
import { DashboardService } from "src/app/services/dashboard.service";
import * as moment from "moment";

@Component({
	selector: "app-topbar",
	templateUrl: "./topbar.component.html",
	styleUrls: ["./topbar.component.scss"],
})
export class TopbarComponent implements OnInit, AfterViewInit, OnDestroy {
	user$: UserModel;
	public unreadAlertsCount: number = 0;
	public showTooltip: boolean = true;
	public avatarSrc: string | null = null;
	public failedAvatarSrcs = new Set<string>();
	private miCuentaSub?: Subscription;
	@Output() hideEuroChange = new EventEmitter<boolean>();
	extraSearchDisplay: boolean;
	extrasSearchLayout: "offcanvas" | "dropdown";
	extrasNotificationsDisplay: boolean;
	extrasNotificationsLayout: "offcanvas" | "dropdown";
	extrasQuickActionsDisplay: boolean;
	extrasQuickActionsLayout: "offcanvas" | "dropdown";
	extrasCartDisplay: boolean;
	extrasCartLayout: "offcanvas" | "dropdown";
	extrasQuickPanelDisplay: boolean;
	extrasLanguagesDisplay: boolean;
	extrasUserDisplay: boolean;
	extrasUserLayout: "offcanvas" | "dropdown";
	newNotificationAlert$: Observable<boolean>;
	private alertListObs$: Observable<RegistroAlerta[]>;
	public alertList: RegistroAlerta[] = [];
	public showAlertExclamation: boolean = false;
	msalUserObs$: Observable<MsalUserProfile>;
	msalUser: MsalUserProfile;
	msalUserLogged: boolean = false;
	public isSuperAdmin: boolean = this.tokenStorage.getUser().superAdmin;

	// Divisas
	public listDivisas: Divisa[] = [];
	public hideEuro: boolean = false;

	constructor(private layout: LayoutService, private auth: AuthService, private tokenStorage: TokenStorageService, private notificationService: NotificationService, private dashboardService: DashboardService, private ref: ChangeDetectorRef, private miCuentaService: MiCuentaService) {
		//this.user$ = this.auth.currentUserSubject.asObservable();
		//this.user$ = this.tokenStorage.currentUser
		this.user$ = new UserModel();
		this.user$.fullname = this.tokenStorage.getUserName();
		this.user$.firstname = this.tokenStorage.getUserFirstName();
		this.user$.lastname = this.tokenStorage.getUserLastName();
		this.newNotificationAlert$ = this.notificationService.newNotification$;
		// this.msalUserObs$ = this.tokenStorage.msalUser$;
		// this.msalUserLogged = this.tokenStorage.msalUserIsLogged();
		// this.msalUserObs$.subscribe((userMsal) => {
		// 	this.msalUser = userMsal;
		// 	//.log(userMsal,this.msalUserLogged);
		// });
		
		this.alertListObs$ = this.notificationService.alertListObservable;
		this.alertListObs$.subscribe((list) => {
			this.alertList = list;
			this.showAlertExclamation = !!(this.alertList && this.alertList.length > 0 && this.alertList.some(alert => !alert.leida));
			this.unreadAlertsCount = this.alertList && this.alertList.length > 0 
			  ? this.alertList.filter(alert => !alert.leida).length 
			  : 0;
		  });
	
	}

	ngOnInit(): void {
		// topbar extras
		this.extraSearchDisplay = this.layout.getProp("extras.search.display");
		this.extrasSearchLayout = this.layout.getProp("extras.search.layout");
		this.extrasNotificationsDisplay = this.layout.getProp("extras.notifications.display");
		this.extrasNotificationsLayout = this.layout.getProp("extras.notifications.layout");
		this.extrasQuickActionsDisplay = this.layout.getProp("extras.quickActions.display");
		this.extrasQuickActionsLayout = this.layout.getProp("extras.quickActions.layout");
		this.extrasCartDisplay = this.layout.getProp("extras.cart.display");
		this.extrasCartLayout = this.layout.getProp("extras.cart.layout");
		this.extrasLanguagesDisplay = this.layout.getProp("extras.languages.display");
		this.extrasUserDisplay = this.layout.getProp("extras.user.display");
		this.extrasUserLayout = this.layout.getProp("extras.user.layout");
		this.extrasQuickPanelDisplay = this.layout.getProp("extras.quickPanel.display");
		this.extrasQuickPanelDisplay = this.layout.getProp("extras.quickPanel.display");
		setTimeout(() => {
			this.showTooltip = false;
		  }, 4000);

		// Avatar del header: se sincroniza con el resumen de Mi Cuenta.
		this.miCuentaSub = this.miCuentaService.resumen$.subscribe((resumen) => {
			this.applyAvatarFromResumen(resumen);
		});
		// Primera carga (la siguiente la dispara Mi Cuenta al guardar cambios).
		this.miCuentaService.getResumen().subscribe(
			() => { /* el subject se actualiza desde el service */ },
			() => { /* silenciamos: si falla mantenemos las iniciales */ }
		);
	}

	ngOnDestroy(): void {
		if (this.miCuentaSub) {
			this.miCuentaSub.unsubscribe();
		}
	}

	private applyAvatarFromResumen(resumen: MiCuentaResumen | null): void {
		const next = MiCuentaService.avatarToSrc(resumen?.avatarSeleccionado);
		if (next && !this.failedAvatarSrcs.has(next)) {
			this.avatarSrc = next;
		} else {
			this.avatarSrc = null;
		}
		this.ref.detectChanges();
	}

	onAvatarLoadError(): void {
		if (this.avatarSrc && !this.avatarSrc.startsWith("data:")) {
			this.failedAvatarSrcs.add(this.avatarSrc);
		}
		this.avatarSrc = null;
		this.ref.detectChanges();
	}
	onSucursalVisibleChange(visible: boolean) {
		this.hideEuro = visible;
		this.hideEuroChange.emit(this.hideEuro);
		this.ref.detectChanges();
	}



	ngAfterViewInit(): void {
		KTUtil.ready(() => {
			if (this.extraSearchDisplay && this.extrasSearchLayout === "offcanvas") {
				KTLayoutQuickSearch.init("kt_quick_search");
			}

			if (this.extrasNotificationsDisplay && this.extrasNotificationsLayout === "offcanvas") {
				KTLayoutQuickNotifications.init("kt_quick_notifications");
			}

			if (this.extrasQuickActionsDisplay && this.extrasQuickActionsLayout === "offcanvas") {
				KTLayoutQuickActions.init("kt_quick_actions");
			}

			if (this.extrasCartDisplay && this.extrasCartLayout === "offcanvas") {
				KTLayoutQuickCartPanel.init("kt_quick_cart");
			}

			if (this.extrasQuickPanelDisplay) {
				KTLayoutQuickPanel.init("kt_quick_panel");
			}
			if (this.extrasUserDisplay && this.extrasUserLayout === "offcanvas") {
				KTLayoutQuickUser.init("kt_quick_user");
			}

			KTLayoutHeaderTopbar.init("kt_header_mobile_topbar_toggle");
		});
	}

	listHasOpen(event) {
		if (event) {
			this.notificationService.newNotificationSubject.next(!event);
			this.showAlertExclamation = false;
			this.notificationService.directAlertRefresh();
		}
	}
}
